<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-15 17:06:35
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="shopIdCell">
		<el-tooltip placement="top" :content="row[column.key]" v-ak-tooltip-auto-show>
			<span class="line-ellipsis-1 yx-color-pure-1" style="width: 100%;">{{ row[column.key] | formatEmpty }}</span>
		</el-tooltip>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	computed: {},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped></style>
